import { render } from "./PigsBatchesTable.vue?vue&type=template&id=1687e440&ts=true"
import script from "./PigsBatchesTable.vue?vue&type=script&lang=ts"
export * from "./PigsBatchesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__